(function () {
  'use strict';

  var POPUP_ID = 'contact-popup';
  var TRIGGER_HREF = '#' + POPUP_ID;
  var lastFocused = null;

  function getPopup() {
    return document.getElementById(POPUP_ID);
  }

  function open(trigger) {
    var popup = getPopup();
    if (!popup) return;
    lastFocused = document.activeElement;
    if (trigger) prefillFromTrigger(popup, trigger);
    var fromProduct = trigger && trigger.getAttribute('data-contact-popup-prefill-model');
    setModelRequired(popup, !fromProduct);
    popup.setAttribute('data-open', 'true');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('contact-popup-open');
    var firstField = popup.querySelector('input, textarea, select, button');
    if (firstField) {
      try { firstField.focus({ preventScroll: true }); } catch (e) { firstField.focus(); }
    }
  }

  function setModelRequired(popup, required) {
    var modelField = findFieldByLabel(popup, 'model');
    if (!modelField) return;
    if (required) {
      modelField.setAttribute('required', 'required');
    } else {
      modelField.removeAttribute('required');
    }
    var label = modelField.id ? popup.querySelector('label[for="' + modelField.id + '"]') : null;
    if (!label) return;
    var asterisk = label.querySelector('.required');
    if (required && !asterisk) {
      var span = document.createElement('span');
      span.className = 'required';
      span.textContent = '*';
      label.appendChild(document.createTextNode(' '));
      label.appendChild(span);
    } else if (!required && asterisk) {
      asterisk.remove();
    }
  }

  function findFieldByLabel(popup, labelMatch) {
    var fields = popup.querySelectorAll('input[type="text"], input[type="tel"], textarea');
    for (var i = 0; i < fields.length; i++) {
      var name = fields[i].getAttribute('name') || '';
      if (name.toLowerCase().indexOf(labelMatch.toLowerCase()) !== -1) return fields[i];
    }
    return null;
  }

  function prefillFromTrigger(popup, trigger) {
    var modelValue = trigger.getAttribute('data-contact-popup-prefill-model');
    if (modelValue) {
      var modelField = findFieldByLabel(popup, 'model');
      if (modelField && !modelField.value) modelField.value = modelValue;
    }

    var sourceValue = trigger.getAttribute('data-contact-popup-prefill-source');
    if (sourceValue) {
      var sourceField = popup.querySelector('input[name="contact[source]"]');
      if (sourceField) sourceField.value = sourceValue;
    }
  }

  function close() {
    var popup = getPopup();
    if (!popup) return;
    popup.removeAttribute('data-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('contact-popup-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus({ preventScroll: true }); } catch (e) { lastFocused.focus(); }
    }
  }

  function isTrigger(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.hasAttribute && el.hasAttribute('data-contact-popup-open')) return true;
    if (el.tagName === 'A' && el.getAttribute('href') === TRIGGER_HREF) return true;
    return false;
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    while (target && target !== document) {
      if (isTrigger(target)) {
        e.preventDefault();
        open(target);
        return;
      }
      if (target.hasAttribute && target.hasAttribute('data-contact-popup-close')) {
        e.preventDefault();
        close();
        return;
      }
      target = target.parentNode;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      var popup = getPopup();
      if (popup && popup.getAttribute('data-open') === 'true') close();
    }
  });

  // Auto-open if a contact form was just submitted (so success/error state stays visible)
  // or if the URL contains ?contact=open or hash #contact-popup.
  document.addEventListener('DOMContentLoaded', function () {
    var popup = getPopup();
    if (!popup) return;

    var params = new URLSearchParams(window.location.search);
    var hasFormState = popup.querySelector('.contact-popup__success, .contact-popup__errors');
    if (params.get('contact') === 'open' || window.location.hash === TRIGGER_HREF || hasFormState) {
      open();
    }

    bindAutoResponseHook(popup);
  });

  // Dual-post: alongside the native /contact submission, fire a customer-creation
  // POST so Shopify Flow can pick up the tag and send an auto-response email.
  function bindAutoResponseHook(popup) {
    var form = popup.querySelector('#contact-popup-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      var emailField = form.querySelector('input[name="contact[email]"]');
      var email = emailField && emailField.value && emailField.value.trim();
      if (!email) return;

      var nameField = findFieldByLabel(popup, 'name');
      var fullName = nameField && nameField.value ? nameField.value.trim() : '';
      var firstName = fullName.split(' ')[0] || '';
      var lastName = fullName.indexOf(' ') !== -1 ? fullName.substring(fullName.indexOf(' ') + 1) : '';

      var sourceField = popup.querySelector('input[name="contact[source]"]');
      var source = sourceField && sourceField.value ? sourceField.value.trim() : '';

      var tags = ['revit-request'];
      if (source) {
        tags.push('source-' + source.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 60));
      }

      var payload = new FormData();
      payload.append('form_type', 'customer');
      payload.append('utf8', '✓');
      payload.append('contact[email]', email);
      if (firstName) payload.append('contact[first_name]', firstName);
      if (lastName) payload.append('contact[last_name]', lastName);
      payload.append('contact[tags]', tags.join(','));
      payload.append('contact[accepts_marketing]', 'false');

      try {
        fetch('/contact', {
          method: 'POST',
          body: payload,
          keepalive: true,
          credentials: 'same-origin'
        });
      } catch (e) {
        // Silent fail — the merchant still gets the contact form notification.
      }
    });
  }
})();
